export const confirmation = [
  { label: "Yes", value: true },
  { label: "No", value: false },
]
export const confirmationMissing = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
  { label: "MISSING DATA", value: "Missing Data" },
]

export const confirmationRefused = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
  { label: "Refused", value: "Refused" },
]

export const confirmationExtended = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
  { label: "Do not know", value: "Do not know" },
  { label: "Refused", value: "Refused" },
]
export const confirmationExtendedwithoutMissingData = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
  { label: "REFUSED", value: "Refused" },
  { label: "DON'T KNOW", value: "Don't know" },
]

export const categories = [
  { label: "Primary", value: "Pimary" },
  { label: "Secondary", value: "Secondary" },
  { label: "Tertiary", value: "Tertiary" },
]
export const ratesTypes = [
  { label: "Very Poor", value: "Very Poor" },
  { label: "Poor", value: "Poor" },
  { label: "Neither poor nor good", value: "Neither poor nor good" },
  { label: "Good", value: "Good" },
  { label: "Very Good", value: "Very good" },
  { label: "Refused", value: "Refused" },
]

export const negationTypes = [
  { label: "REFUSED", value: "Refused" },
  { label: "DON'T KNOW", value: "Don't know" },
  { label: "MISSING DATA", value: "Missing data" },
]

export const refused = [{ label: "REFUSED", value: "Refused" }]

export const negationTypesShort = [
  { label: "REFUSED", value: "Refused" },
  { label: "DON'T KNOW", value: "Don't know" },
]

export const arrestedTimes = [
  { label: "Refused", value: "Refused" },
  { label: "Currently Incarcerated", value: "Currently Incarcerated" },
  { label: "Not Applicable", value: "Not Applicable" },
]

export const paroleTypes = [
  { label: "Probation", value: "Probation" },
  { label: "Parole", value: "Parole" },
  {
    label: "Intensive Pretrial Supervision",
    value: "Intensive Pretrial Supervision",
  },
  { label: "No", value: "No" },
  { label: "Refused", value: "Refused" },
]

export const drugCourtProgram = [
  { label: "Drug court program", value: "Drug court program" },
  {
    label: "Deferred prosecution agreement",
    value: "Deferred prosecution agreement",
  },
  {
    label: "No, neither of these",
    value: "No, neither of these",
  },
  {
    label: "Refused",
    value: "Refused",
  },
]

export const clientTypes = [
  { label: "Treatment grant client", value: "Treatment grant client" },
  { label: "Client in recovery grant", value: "Client in recovery grant" },
]

export const interviewTypes = [
  { label: "Intake", value: "Intake" },
  { label: "6-month follow-up", value: "FollowUp" },
  { label: "Discharge", value: "Discharge" },
]

export const genderTypes = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  {
    label: "Transgender (Male to Female)",
    value: "Transgender (Male to Female)",
  },
  {
    label: "Transgender (Female to Male)",
    value: "Transgender (Female to Male)",
  },
  { label: "Gender non-conforming", value: "Gender non-conforming" },
  { label: "Other (Specify)", value: "Other" },
  { label: "Refused", value: "Refused" },
]

export const militaryServedTypes = [
  { label: "No", value: "No" },
  { label: "Yes, in the armed forces", value: "Yes, in the armed forces" },
  { label: "Yes, in the reserves", value: "Yes, in the reserves" },
  { label: "Yes, in the national guard", value: "Yes, in the national guard" },
  {
    label: "Yes, Other Uniformed Services [Includes NOAA, USPHS]",
    value: "Yes, in Other Uniformed Services",
  },
  { label: "Refused", value: "Refused" },
]

export const timeTravel = [
  { label: "Half an hour or less", value: "Half an hour or less" },
  {
    label: "Between half an hour and one hour",
    value: "Between half an hour and one hour",
  },
  {
    label: "Between one hour and one and a half hours",
    value: "Between one hour and one and a half hours",
  },
  {
    label: "Between one and a half hours and two hours",
    value: "Between one and a half hours and two hours",
  },
  { label: "Two hours or more", value: "Two hours or more" },
  { label: "Refused", value: "Refused" },
]
export const militaryActuallyServedTypes = [
  {
    label:
      "NO, SEPARATED OR RETIRED FROM THE ARMED FORCES, RESERVES, OR NATIONAL GUARD",
    value:
      "No, separated or retired from the armed forces, reserves, o national guard",
  },
  { label: "YES, IN THE ARMED FORCES", value: "Yes, in the armed forces" },
  { label: "YES, IN THE RESERVES", value: "Yes, in the reserves" },
  { label: "YES, IN THE NATIONAL GUARD", value: "Yes, in the national guard" },
  { label: "REFUSED", value: "Refused" },
  { label: "DON'T KNOW", value: "Don't know" },
]
export const militaryFamiliyConfirmationTypes = [
  { label: "NO", value: "No" },
  { label: "YES, ONLY ONE", value: "Yes, only one" },
  { label: "YES, MORE THAN ONE", value: "Yes, more than one" },
  { label: "REFUSED", value: "Refused" },
  { label: "DON'T KNOW", value: "Don't know" },
  { label: "MISSING DATA", value: "Missing data" },
]
export const drugsAdministrationTypes = [
  { label: "Oral", value: 1 },
  { label: "Intranasal", value: 2 },
  { label: "Vaping", value: 6 },
  { label: "Smoking", value: 3 },
  { label: "Non- Intravenous (IV) injection", value: 4 },
  { label: "Intravenous (IV) injection", value: 5 },
  { label: "Other", value: 0 },
]
export const familyRelationship = [
  { label: "Mother", value: "Mother" },
  { label: "Father", value: "Father" },
  { label: "Brother", value: "Brother" },
  { label: "Sister", value: "Sister" },
  { label: "Spouse", value: "Spouse" },
  { label: "Partner", value: "Partner" },
  { label: "Child", value: "Child" },
  { label: "Other (Specify)", value: "Other" },
]
export const familyHouseTypes = [
  { label: "Shelter", value: "Shelter" },
  { label: "Street/Outdoors", value: "Street/Outdoors" },
  { label: "Institution", value: "Institution" },
  { label: "Housed", value: "Housed" },
  { label: "Refused", value: "Refused" },
]

export const liveWithPerson = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
  { label: "No, lives alone", value: "No, lives alone" },
  { label: "Refused", value: "Refused" },
]
export const familyHousingTypes = [
  {
    label: "Own/rent apartment, room or house",
    value: "Own/rent apartment, room or house",
  },
  {
    label: "Someone else's apartment, room or house",
    value: "Someone else's apartment, room or house",
  },
  {
    label: "Dormitory/College Residence",
    value: "Dormitory/College Residence",
  },
  { label: "Halfway house", value: "Halfway house" },
  { label: "Residential treatment", value: "Residential treatment" },
  {
    label: "Recovery Residence/Sober Living",
    value: "Recovery Residence/Sober Living",
  },
  { label: "Other housed", value: "Other housed" },
  { label: "Refused", value: "Refused" },
]
export const satisfactionTypes = [
  { label: "Very Dissatisfied", value: "Very Dissatisfied" },
  { label: "Dissatisfied", value: "Dissatisfied" },
  {
    label: "Neither Satisfied nor Dissatisfied",
    value: "Neither Satisfied nor Dissatisfied",
  },
  { label: "Satisfied", value: "Satisfied" },
  { label: "Very Satisfied", value: "Very Satisfied" },
  { label: "Refused", value: "Refused" },
]
export const familyStressTypes = [
  { label: "Not at all", value: "Not at all" },
  { label: "Somewhat", value: "Somewhat" },
  { label: "Considerably", value: "Considerably" },
  { label: "Extremely", value: "Extremely" },
  { label: "Not Applicable", value: "Not Applicable" },
  { label: "REFUSED", value: "REFUSED" },
  { label: "DON'T KNOW", value: "Don't know" },
  { label: "MISSING DATA", value: "Missing data" },
]
export const enrolledEducationTypes = [
  { label: "Not enrolled", value: "Not enrolled" },
  { label: "Enrolled, Full time", value: "Enrolled, Full time" },
  { label: "Enrolled, Part time", value: "Enrolled, Part time" },
  { label: "Refused", value: "Refused" },
]
export const employedTypes = [
  { label: "Employed full time", value: "Employed full time" },
  { label: "Employed part time", value: "Employed part time" },
  {
    label: "Unemployed, looking for work",
    value: "Unemployed, looking for work",
  },
  {
    label: "Not Employed, NOT Looking for work",
    value: "Not Employed, NOT Looking for work",
  },
  {
    label: "Not working due to a disability",
    value: "Not working due to a disability",
  },
  { label: "Retired, not working", value: "Retired, not working" },
  { label: "Other (Specify)", value: "Other" },
  { label: "Refused", value: "Refused" },
]
export const educationLevelTypes = [
  { label: "Less than 12th Grade", value: "Less than 12th Grade" },
  {
    label: "12th Grade/High School Diploma/Equivalent",
    value: "12th Grade/High School Diploma/Equivalent",
  },
  {
    label: "Vocational/Technical (Voc/Tech) Diploma",
    value: "Vocational/Technical (Voc/Tech) Diploma",
  },
  { label: "Some College or University", value: "Some College or University" },
  {
    label: "Bachelor’s Degree (For example: BA, BS)",
    value: "Bachelor’s Degree (For example: BA, BS)",
  },
  {
    label: "Graduate Work/Graduate Degree",
    value: "Graduate Work/Graduate Degree",
  },
  { label: "Other (Specify)", value: "Other" },
  { label: "Refused", value: "Refused" },
  { label: "Don't Know", value: "Don't know" },
]
export const haveEnoughMoneyTypes = [
  { label: "Food", value: "Food" },
  { label: "Clothing", value: "Clothing" },
  { label: "Transportation", value: "Transportation" },
  { label: "Rent/Housing", value: "Rent/Housing" },
  {
    label: "Utilities (Gas/Water/Electric)",
    value: "Utilities (Gas/Water/Electric)",
  },
  {
    label: "Telephone Connection (Cell or Landline)",
    value: "Telephone Connection (Cell or Landline)",
  },
  { label: "Childcare", value: "Childcare" },
  { label: "Health Insurance", value: "Health Insurance" },
  { label: "Refused", value: "Refused" },
]

export const moneyNeededTypes = [
  { label: "Not at all", value: "Not at all" },
  { label: "A little", value: "A little" },
  { label: "Moderately", value: "Moderatly" },
  { label: "Mostely", value: "Mostely" },
  { label: "Completely", value: "Completely" },
  { label: "REFUSED", value: "Refused" },
  { label: "DON'T KNOW", value: "Don't know" },
  { label: "MISSING DATA", value: "Missing data" },
]

export const annualIncome = [
  { label: "$0 to $9,999", value: "$0 to $9,999" },
  { label: "$10,000 to $14,999", value: "$10,000 to $14,999" },
  { label: "$15,000 to $19,999", value: "$15,000 to $19,999" },
  { label: "$20,000 to $34,999", value: "$20,000 to $34,999" },
  { label: "$35,000 to $49,999", value: "$35,000 to $49,999" },
  { label: "$50,000 to $74,999", value: "$50,000 to $74,999" },
  { label: "$75,000 to $99,999", value: "$75,000 to $99,999" },
  { label: "$100,000 to $199,999", value: "$100,000 to $199,999" },
  { label: "$200,000 or more", value: "$200,000 or more" },
  { label: "Refused", value: "Refused" },
]

export const qualityOfLifeTypes = [
  { label: "Very Poor", value: "Very Poor" },
  { label: "Poor", value: "Poor" },
  { label: "Neither poor nor good", value: "Neither poor nor good" },
  { label: "Good", value: "Good" },
  { label: "Very good", value: "Very good" },
  { label: "Refused", value: "Refused" },
]
export const healthEnergyTypes = [
  { label: "Not at all", value: "Not at all" },
  { label: "A little", value: "A little" },
  { label: "Moderately", value: "Moderatly" },
  { label: "Mostly", value: "Mostly" },
  { label: "Completely", value: "Completely" },
  { label: "REFUSED", value: "Refused" },
  { label: "DON'T KNOW", value: "Don't know" },
  { label: "MISSING DATA", value: "Missing data" },
]

export const oftenTypes = [
  { label: "Never", value: "Never" },
  { label: "A few times", value: "A few times" },
  { label: "More than a few times", value: "More than a few times" },
  { label: "REFUSED", value: "Refused" },
  { label: "DON'T KNOW", value: "Don't know" },
  { label: "MISSING DATA", value: "Missing data" },
]
export const extentTypes = [
  { label: "To a Great Extent", value: "To a great extent" },
  { label: "Somewhat", value: "Somewhat" },
  { label: "Very Little", value: "Very little" },
  { label: "Not at all", value: "Not at all" },
  { label: "Refused", value: "Refused" },
]
export const followUpStatusTypes = [
  {
    label: "Deceased at time of due date",
    value: 1,
  },
  {
    label: "Completed interview within specified window",
    value: 11,
  },
  {
    label: "Completed interview outside specified window",
    value: 12,
  },
  {
    label: "Located, but refused, unespecified",
    value: 21,
  },
  {
    label: "Located, but unable to gain institutional access",
    value: 22,
  },
  {
    label: "Located, but otherwise unable to gain access",
    value: 23,
  },
  {
    label: "Located, but withdraw from project",
    value: 24,
  },
  { label: "Unable to locate, moved", value: 31 },
  { label: "Unable to locate, other", value: 32 },
]
export const dischargeStatusTypes = [
  { label: "Completion/Graduate", value: 1 },
  { label: "Termination", value: 2 },
]
export const dischargeReasonStatusTypes = [
  {
    label: "Left on own against staff advice with satisfactory progress",
    value: 1,
  },
  {
    label: "Left on own against staff advice without satisfactory progress",
    value: 2,
  },
  {
    label: "Involuntarily discharged due to nonparticipation",
    value: 3,
  },
  {
    label: "Involuntarily discharged due to violation of rules",
    value: 4,
  },
  {
    label:
      "Referred to another program or other services with satisfactory progress",
    value: 5,
  },
  {
    label:
      "Referred to another program or other services with unsatisfactory progress",
    value: 6,
  },
  {
    label:
      "Incarcerated due to offense committed while in treatment/recovery with satisfactory progress",
    value: 7,
  },
  {
    label:
      "Incarcerated due to offense committed while in treatment/recovery with unsatisfactory progress",
    value: 8,
  },
  {
    label:
      "Incarcerated due to old warrant or charged from before entering treatment/recovery with satisfactory progress",
    value: 9,
  },
  {
    label:
      "Incarcerated due to old warrant or charged from before entering treatment/recovery with unsatisfactory progress",
    value: 10,
  },
  {
    label: "Transferred to another facility for health reasons",
    value: 11,
  },
  { label: "Death", value: 12 },
  { label: "Other", value: 13 },
]

export const sexualActivityConfirmation = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
  { label: "Not permitted to ask", value: "Not permitted to ask" },
  { label: "REFUSED", value: "Refused" },
  { label: "DON'T KNOW", value: "Don't know" },
]

export const mentalBotheredTypes = [
  { label: "Not at all", value: "Not at all" },
  { label: "Slightly", value: "Slightly" },
  { label: "Moderately", value: "Moderatly" },
  { label: "Considerably", value: "Considerably" },
  { label: "Extremely", value: "Extremely" },
  { label: "Refused", value: "Refused" },
  {
    label: "No reported mental health complaints in the past 30 days",
    value: "No reported mental health complaints in the past 30 days",
  },
]

export const recivedMedicalCare = [
  { label: "Primary Care Provider", value: "Primary Care Provider" },
  { label: "Urgent Care", value: "Urgent Care" },
  { label: "The Emergency Department", value: "The Emergency Department" },
  { label: "A specialist doctor", value: "A specialist doctor" },
  { label: "No care was sought", value: "No care was sought" },
  { label: "Other", value: "Other" },
]

export const typeOfInsurance = [
  { label: "Medicare", value: "Medicare" },
  { label: "Medicaid", value: "Medicaid" },
  {
    label: "Private Insurance or Employer Provided",
    value: "Private Insurance or Employer Provided",
  },
  {
    label: "TRICARE or other military health care",
    value: "TRICARE or other military health care",
  },
  {
    label:
      "An assistance program [for example, a medication assistance program]",
    value:
      "An assistance program [for example, a medication assistance program]",
  },
  {
    label:
      "Any other type of health insurance or health coverage plan (Specify)",
    value: "Other",
  },
  { label: "Refused", value: "Refused" },
]

export const whornSocialTypes = [
  { label: "No one", value: "No one" },
  { label: "Clergy member", value: "Clergy member" },
  { label: "Family member", value: "Family member" },
  { label: "Friends", value: "Friends" },
  { label: "Other", value: "Other" },
  { label: "REFUSED", value: "REFUSED" },
  { label: "DON'T KNOW", value: "DON'T KNOW" },
  { label: "MISSING DATA", value: "MISSING DATA" },
]

export const ethnicTypes = [
  { label: "Central American", value: "Central American" },
  { label: "Cuban", value: "Cuban" },
  { label: "Dominican", value: "Dominican" },
  { label: "Mexican", value: "Mexican" },
  { label: "Puerto Rican", value: "Puerto Rican" },
  { label: "South American", value: "South American" },
  { label: "Other (Specify)", value: "Other" },
  { label: "Refused", value: "Refused" },
]

export const raceTypes = [
  { label: "Black or African American", value: "Black or African American" },
  { label: "White", value: "White" },
  { label: "American Indian", value: "American Indian" },
  { label: "Alaska Native", value: "Alaska Native" },
  { label: "Asian Indian", value: "Asian Indian" },
  { label: "Chinese", value: "Chinese" },
  { label: "Filipino", value: "Filipino" },
  { label: "Japanese", value: "Japanese" },
  { label: "Korean", value: "Korean" },
  { label: "Vietnamese", value: "Vietnamese" },
  { label: "Other Asian", value: "Other Asian" },
  { label: "Native Hawaiian", value: "Native Hawaiian" },
  { label: "Guamanian or Chamorro", value: "Guamanian or Chamorro" },
  { label: "Samoan", value: "Samoan" },
  { label: "Other Pacific Islander", value: "Other Pacific Islander" },
  { label: "Other (Specify)", value: "Other" },
  { label: "Refused", value: "Refused" },
]

export const lenguageConfirmation = [
  { label: "Spanish", value: "Spanish" },
  { label: "Other", value: "Other" },
]

export const thinkOfYourselfTypes = [
  { label: "Straight Or Heterosexual", value: "Straight Or Heterosexual" },
  {
    label: "Homosexual (Gay Or Lesbian)",
    value: "Homosexual (Gay Or Lesbian)",
  },
  { label: "Bisexual", value: "Bisexual" },
  {
    label: "Queer, Pansexual, And/Or Questioning",
    value: "Queer, Pansexual, And/Or Questioning",
  },
  { label: "Asexual", value: "Asexual" },
  { label: "Something Else? Please Specify", value: "Other" },
  { label: "Refused", value: "Refused" },
]

export const relationshipStatusTypes = [
  { label: "Married", value: "Married" },
  { label: "Single", value: "Single" },
  { label: "Divorced", value: "Divorced" },
  { label: "Separated", value: "Separated" },
  { label: "Widowed", value: "Widowed" },
  { label: "In a relationship", value: "In a relationship" },
  { label: "In multiple relationships", value: "In multiple relationships" },
  { label: "Refused", value: "Refused" },
]

export const overdosingIntervention = [
  { label: "Naloxone (Narcan)", value: "Naloxone (Narcan)" },
  {
    label: "Care in an Emergency Department",
    value: "Care in an Emergency Department",
  },
  {
    label: "Care from a Primary Care Provider",
    value: "Care from a Primary Care Provider",
  },
  {
    label: "Admission to a hospital",
    value: "Admission to a hospital",
  },
  {
    label: "Supervision by someone else",
    value: "Supervision by someone else",
  },
  {
    label: "Other (Specify)",
    value: "Other",
  },
  {
    label: "Refused",
    value: "Refused",
  },
]

export const treatmentTimes = [
  { label: "One time", value: "One time" },
  { label: "Two times", value: "Two times" },
  { label: "Three times", value: "Three times" },
  { label: "Four times", value: "Four times" },
  { label: "Five times", value: "Five times" },
  { label: "Six or more times", value: "Six or more times" },
  { label: "Never", value: "Never" },
  { label: "Refused", value: "Refused" },
]
export const lastTimeTreatment = [
  { label: "Less than 6 months ago", value: "Less than 6 months ago" },
  {
    label: "Between 6 months and one year ago",
    value: "Between 6 months and one year ago",
  },
  { label: "One to two years ago", value: "One to two years ago" },
  { label: "Two to three years ago", value: "Two to three years ago" },
  { label: "Three to four years ago", value: "Three to four years ago" },
  { label: "Five or more years ago", value: "Five or more years ago" },
  { label: "Refused", value: "Refused" },
]

export const nonMoodPhyscoDisorders = [
  { label: "Brief psychotic disorder", value: "Brief psychotic disorder" },
  { label: "Delusional disorder", value: "Delusional disorder" },
  { label: "Schizoaffective disorders", value: "Schizoaffective disorders" },
  { label: "Schizophrenia", value: "Schizophrenia" },
  { label: "Schizotypal disorder", value: "Schizotypal disorder" },
  { label: "Shared psychotic disorder", value: "Shared psychotic disorder" },
  { label: "Unspecified psychosis", value: "Unspecified psychosis" },
]
export const moodDisorders = [
  { label: "Bipolar disorder", value: "Bipolar disorder" },
  {
    label: "Major depressive disorder, recurrent",
    value: "Major depressive disorder, recurrent",
  },
  {
    label: "Major depressive disorder, single episode",
    value: "Major depressive disorder, single episode",
  },
  { label: "Manic episode", value: "Manic episode" },
  {
    label: "Persistent mood [affective] disorders",
    value: "Persistent mood [affective] disorders",
  },
  {
    label: "Unspecified mood [affective] disorder",
    value: "Unspecified mood [affective] disorder",
  },
]
export const anxietyDisorders = [
  {
    label: "Agoraphobia without panic disorder",
    value: "Agoraphobia without panic disorder",
  },
  {
    label: "Agoraphobia with panic disorder",
    value: "Agoraphobia with panic disorder",
  },
  { label: "Agoraphobia, unspecified", value: "Agoraphobia, unspecified" },
  {
    label: "Generalized anxiety disorder",
    value: "Generalized anxiety disorder",
  },
  { label: "Panic disorder", value: "Panic disorder" },
  {
    label: "Phobic anxiety disorders",
    value: "Phobic anxiety disorders",
  },
  {
    label: "Social phobias (Social anxiety disorder)",
    value: "Social phobias (Social anxiety disorder)",
  },
  {
    label: "Specific (isolated) phobias",
    value: "Specific (isolated) phobias",
  },
]
export const obsessiveCompulsiveDisorders = [
  {
    label: "Excoriation (skin-picking) disorder",
    value: "Excoriation (skin-picking) disorder",
  },
  {
    label: "Hoarding disorder",
    value: "Hoarding disorder",
  },
  {
    label: "Obsessive-compulsive disorder",
    value: "Obsessive-compulsive disorder",
  },
  {
    label:
      "Obsessive-compulsive disorder with mixed obsessional thoughts and acts",
    value:
      "Obsessive-compulsive disorder with mixed obsessional thoughts and acts",
  },
]
export const adjustmentDisorders = [
  {
    label:
      "Acute stress disorder; reaction to severe stress, and adjustment disorders",
    value:
      "Acute stress disorder; reaction to severe stress, and adjustment disorders",
  },
  {
    label: "Adjustment disorders",
    value: "Adjustment disorders",
  },
  {
    label: "Body dysmorphic disorder",
    value: "Body dysmorphic disorder",
  },
  {
    label: "Dissociative and conversion disorders",
    value: "Dissociative and conversion disorders",
  },
  {
    label: "Dissociative identity disorder",
    value: "Dissociative identity disorder",
  },
  {
    label: "Post traumatic stress disorder",
    value: "Post traumatic stress disorder",
  },
  {
    label: "Somatoform disorders",
    value: "Somatoform disorders",
  },
]
export const behavioralSyndroms = [
  {
    label: "Eating disorders",
    value: "Eating disorders",
  },
  {
    label:
      "Sleep disorders not due to a substance or known physiological condition",
    value:
      "Sleep disorders not due to a substance or known physiological condition",
  },
]

export const adultPersonalityDisorders = [
  {
    label: "Antisocial personality disorder",
    value: "Antisocial personality disorder",
  },
  {
    label: "Avoidant personality disorder",
    value: "Avoidant personality disorder",
  },
  {
    label: "Borderline personality disorder",
    value: "Borderline personality disorder",
  },
  {
    label: "Dependent personality disorder",
    value: "Dependent personality disorder",
  },
  {
    label: "Histrionic personality disorder",
    value: "Histrionic personality disorder",
  },
  {
    label: "Intellectual disabilities",
    value: "Intellectual disabilities",
  },
  {
    label: "Obsessive-compulsive personality disorder",
    value: "Obsessive-compulsive personality disorder",
  },
  {
    label: "Other specific personality disorders",
    value: "Other specific personality disorders",
  },
  {
    label: "Paranoid personality disorder",
    value: "Paranoid personality disorder",
  },
  {
    label: "Personality disorder, unspecified",
    value: "Personality disorder, unspecified",
  },
  {
    label: "Pervasive and specific developmental disorders",
    value: "Pervasive and specific developmental disorders",
  },
  {
    label: "Schizoid personality disorder",
    value: "Schizoid personality disorder",
  },
]

export const testStrips = [
  { label: "Naloxone", value: "Naloxone" },
  { label: "Fentanyl Test Strips", value: "Fentanyl Test Strips" },
  {
    label: "Both Naloxone and Fentanyl Test Strips",
    value: "Both Naloxone and Fentanyl Test Strips",
  },
  {
    label: "Neither",
    value: "Neither",
  },
]

export const covidVaccinated = [
  { label: "Yes", value: "Yes" },
  {
    label:
      "No, partially vaccinated with plans to receive the subsequent vaccination on time",
    value:
      "No, partially vaccinated with plans to receive the subsequent vaccination on time",
  },
  {
    label:
      "No, partially vaccinated with no plan to receive the subsequent vaccination",
    value:
      "No, partially vaccinated with no plan to receive the subsequent vaccination",
  },
  {
    label: "No, client refused vaccination",
    value: "No, client refused vaccination",
  },
  {
    label: "Refused to answer",
    value: "Refused to answer",
  },
]
